/**
 * Minuscules, sans accents, sans ponctuation.
 * Sert à comparer des libellés saisis librement : « B7L9 Art centre » et
 * « B7L9 Art Centre » doivent désigner le même lieu.
 */
export function normalizeString(s: unknown): string {
  return (s ?? '').toString().toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]/g, '')
    .trim();
}
